.camera {
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.cameraCanvas,
.cameraCanvasSelfie,
.cameraCanvasSelfieDesk {
  z-index: 3;
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
}

.cameraCanvasSelfie,
.cameraCanvasSelfieDesk {
  transform: scale(-1, 1);
  -webkit-transform: scale(-1, 1);
}

.cameraVideo,
.cameraVideoSelfie,
.cameraVideoSelfieDesk {
  z-index: 2;
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
}

.cameraVideoSelfie,
.cameraVideoSelfieDesk {
  transform: scale(-1, 1);
  -webkit-transform: scale(-1, 1);
}

.id-guide-rectangle-white,
.id-guide-rectangle-yellow,
.id-guide-rectangle-green {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  padding-bottom: calc(70% / 1.58);
  border: 3px dashed rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  z-index: 5;
  pointer-events: none;
  box-sizing: border-box;
}

.id-guide-rectangle-yellow {
  border: 3px dashed rgba(250, 253, 38, 0.7);
}

.id-guide-rectangle-green {
  border: 3px dashed rgba(0, 255, 0, 0.7);
}

.countdown-overlay-style {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 6;
}

.video-overlay-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 7;
  pointer-events: none;
}

.capture-flash-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0;
  animation: capture-flash 0.2s ease-out;
  pointer-events: none;
  z-index: 10;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

.animate-bounce {
  animation: bounce 1s infinite;
}

@keyframes capture-flash {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.countdown-text-style {
  color: white; /* text-white */
  font-size: 8rem; /* text-9xl (approx 128px) */
  font-weight: bold; /* font-bold */
  animation: bounce 1s infinite; /* animate-bounce */
}

.take-photo {
  height: 36px;
  background: #7BB40E;
  border-radius: 50px;
  padding: 14px;
}